
export type V2 = [number, number];

export const emptyV2: V2 = [0, 0];

export const newV2 = (x = 0, y = 0): V2 => [x, y];

export const isSameV2 = (v1: V2, v2: V2): boolean => {
  return v1[0] === v2[0] && v1[1] === v2[1];
};

export const addV2 = (v: V2, [x, y]: V2): V2 => {
  v[0] += x;
  v[1] += y;
  return v;
};

export const subtractV2 = (v: V2, [x, y]: V2): V2 => {
  v[0] -= x;
  v[1] -= y;
  return v;
};

export const scaleV2 = (v: V2, scale: number): V2 => {
  v[0] *= scale;
  v[1] *= scale;
  return v;
};

export const getDistance = ([x1, y1]: V2, [x2, y2]: V2): number => {
  return Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
};

export const getAngleRad = ([x1, y1]: V2, [x2, y2]: V2): number => {
  return Math.atan2(y2 - y1, x2 - x1);
};
